<template>
  <div class="application-sidebar">
    <div
        :class="[
        'application-sidebar__wrapper',
        { 'application-sidebar__wrapper_bordered': role === 'APPROVING_PERSON' },
      ]"
    >
      <div
          :class="['application-sidebar__head', { head_detached: isHeadDetached }]"
      >
        <div class="application-sidebar__title">{{ title }}</div>
        <VAutocomplete
            class="application-sidebar__select"
            :items="filterOptions?.division"
            v-model="selectedFilters.division_id"
            placeholder="Выберите подразделение"
            item-value="id"
            item-text="label"
        />
      </div>
      <div
          :class="['application-sidebar__head', { head_detached: isHeadDetached }]"
      >
        <div class="application-sidebar__title">Юридическое лицо</div>
        <VAutocomplete
            class="application-sidebar__select"
            :items="filterOptions?.legalEntity"
            v-model="selectedFilters.legal_entity_id"
            placeholder="Выберите юр. лицо"
            item-value="id"
            item-text="label"
        />
      </div>
      <div :class="['application-sidebar__main']">
        <div style="margin-bottom: 16px" class="application-sidebar__title">Заявка</div>
        <div class="application-sidebar__field-wrapper">
          <div class="application-sidebar__field-label">Статус</div>
          <div class="application-sidebar__field-row">
            <VMultiSelect
                class="application-sidebar__select"
                placeholder="Выберите статус"
                label="Статус"
                :id="23"
                :options="filterOptions?.status"
                :isWithReset="true"
                v-model="selectedFilters.status"
            />
          </div>
        </div>
        <div class="application-sidebar__field-wrapper">
          <div class="application-sidebar__field-label">Приоритет</div>
          <div class="application-sidebar__field-row">
            <VMultiSelect
                class="application-sidebar__select"
                placeholder="Выберите приоритет"
                label="Приоритет"
                :id="2"
                :options="filterOptions?.priority"
                :isWithReset="true"
                v-model="selectedFilters.priority"
            />
          </div>
        </div>
        <div class="application-sidebar__field-wrapper">
          <div class="application-sidebar__field-label">Локация</div>
            <VCustomInput
                class="application-sidebar__select"
                placeholder="Введите название города"
                v-model="selectedFilters.place_of_work"
            />
        </div>
        <div class="application-sidebar__field-wrapper">
          <div class="application-sidebar__field-label">
            Должность
          </div>
          <div style="position:relative;">
            <VCustomInput placeholder="Выберите должность"
                          v-model="specialityName" id="speciality" @input="debouncedSearchSpecialties" btn-clear
                          class="application-sidebar__inp"/>
            <p class="application-sidebar__inp-error" v-if="specialityName && searchNoResul">Такой
              должности нет
              в базе</p>

            <div class="application-sidebar__section-search-results"
                 v-if="specialityName && showSelectSpeciality && specialtiesList.length">
              <div class="application-sidebar__section-search-result" v-for="item in specialtiesList"
                   :key="item.id" :class="{
                        'application-sidebar__section-search-result_active':
                            selectedFilters.speciality_id === item.id,
                    }" @click="selectSpeciality(item)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="application-sidebar__field-wrapper">
          <div class="application-sidebar__field-label">Дата добавления</div>
          <div class="application-sidebar__field-row">
            <div class="application-sidebar__date-label">От</div>
            <VDate
                class="application-sidebar__date"
                id="addDateFrom"
                mode="date"
                placeholder="дд.мм.гггг"
                @update:modelValue="onCreatedAtFrom"
                @dateInput="onDateFrom"
                v-model="selectedFilters.created_at_to"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import VMultiSelect from "@/components/UI/VMultiSelect";
import { debounce } from "@/services/helpers";
import {useRoute, useRouter} from "vue-router";
import specialties from "@/api/specialties";
import VCustomInput from "@/components/UI/VCustomInput/index.vue";
import VAutocomplete from "@/components/UI/VAutocomplete/index.vue";

const router = useRouter()
const route = useRoute()
const emit = defineEmits([
  "update:modelValue",
  "filterSelected",
  "vacancyTypeSelect",
  "vacancyStepSelect",
  "vacancyApprovalFilterSelect",
]);
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  title: {
    type: String,
    required: false,
  },
  subtitle: {
    type: String,
    required: false,
  },
  isHeadDetached: {
    type: Boolean,
    default: true,
  },
  role: {
    type: String,
  },
  modelValue: {
    type: Object,
    required: true,
  },
  filterOptions: {
    type: Object,
  },
});

let selectedFilters = ref({
  legal_entity_id: null,
  division_id: null,
  speciality_id: [],
  status: [],
  priority: [],
  place_of_work: null,
  specialities: [],
  created_at_to: "",
  // "experience[to]": null,
  created_at_to_query: "",
  // created_at_from: "",
  // experience_from: null,
  // "experience[from]": null,
  // experience_to: null,
  // "created_at[from]": "",
  // responsible_hr: null,
  // source: [],
  // labels: [],
  // jobTitle: [],
});
const specialityName = ref('')
const searchNoResul = ref(false);
const showSelectSpeciality = ref(false)
const specialtiesList = ref([]);

const debouncedSearchSpecialties = debounce(() => searchSpecialties(), 400)
const searchSpecialties = async () => {
  setTimeout(() => {
    showSelectSpeciality.value = true
  }, 150)

  if (specialityName.value?.length) {
    selectedFilters.value.speciality_id = []
  }

  try {
    specialtiesList.value = await specialties.getSearchSpecialties({
      search: specialityName.value,
    });

    searchNoResul.value = !specialtiesList.value.length ? true : false

  } catch (error) {
  }
};

const selectSpeciality = (option) => {
  selectedFilters.value.speciality_id.push(option.id)
  specialityName.value = option.name
  showSelectSpeciality.value = false
};

const onCreatedAtFrom = (val) => {
  selectedFilters.value.created_at_to_query = val.toISOString().split("T")[0];
};

const onDateFrom = (val) => {
  if (!val) {
    selectedFilters.value.created_at_to_query = "";
  }
};

watch(
    selectedFilters,
    (newVal, OldVal) => {
      router.replace({query: {...route.query, filters: JSON?.stringify(selectedFilters.value)}});
      emit("update:modelValue", selectedFilters.value);
    },
    { deep: true, immediate: false }
);

onMounted(async () => {
  // const res = await common.getVacanciesReferences();
  if(route.query?.filters) {
    selectedFilters.value = JSON.parse(route.query?.filters)
  }
  // if (res?.data)
  //   resultsVacancy.value = res?.data.map((item) => ({
  //     id: item?.id,
  //     name: item?.title,
  //   }));
  // const options = await common.getResponsibleHrOptions();
  // if(options?.list) {
  //   responsibleHrOptions.value = options?.list
  // }
});
</script>

<style scoped lang="scss">
.application-sidebar {
  flex-grow: 0;
  border-radius: 16px;

  :deep(.v-select__options) {
    max-height: 312px;
    overflow-y: auto;
    scrollbar-width: thin;
  }

  &__wrapper {
    border-radius: 16px 16px 0 0;

    &_bordered {
      border-radius: 16px;
    }
  }

  &__head {
    padding: 16px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.04);
  }

  &__main {
    padding: 16px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.04);
  }

  &__footer {
    padding: 12px 12px 16px 12px;
    border-top: solid 1px $light-gray-1;
    background-color: #fff;
    box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.04);
    border-radius: 0 0 16px 16px;
  }

  &__title {
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: 600;
  }
  &__candidate-title {
    margin-bottom: 16px;
    font-size: 18px;
    font-weight: 600;
    line-height: 21.78px;
  }

  &__subtitle {
    margin-bottom: 16px;
    font-size: 18px;
    font-weight: 600;
  }

  &__field-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    row-gap: 12px;
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  &__field-row {
    display: flex;
    justify-content: stretch;
    align-items: center;
    flex: 1 1 100%;
    gap: 12px;
  }

  &__field-label {
    color: var($dark);
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
  }

  &__select {
    width: 100%;
    height: 48px;

    :deep(.v-select__header) {
      height: 48px;
    }

    :deep(.v-input) {
      height: 48px;
    }

    :deep(.v-select__header-value) {
      top: 12px;
      padding-right: 20px;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow-x: hidden;
      font-weight: 500;
    }
    :deep(.v-select__header_selected) {
      .v-select__header-palceholder {
        top: 2px;
        display: none;
      }
    }
    :deep(.v-select__header-palceholder) {
      color: $gray;
    }
    :deep(.v-input__placeholder) {
      color: $gray;
    }
  }

  &__date {
    flex: 0 0 auto;
    :deep(.app-date__date-inp-wrapper) {
      height: 48px;
      width: 193px;
    }
    :deep(.app-date__date-inp) {
      &::placeholder {
        color: $gray;
      }
    }
  }

  &__date-label {
    min-width: 19px;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
    color: #8f9cac;
  }

  &__btns {
    width: 100%;
  }

  &__btn {
    width: 100%;
    height: 40px;
    padding: 0 12px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: 0.3s;
    cursor: pointer;

    &_active {
      background-color: #f0f2f4;
    }

    &_with-fio {
      width: 100%;
      height: 40px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      transition: 0.3s;
      cursor: pointer;
    }
  }

  &__btn-row {
    display: flex;
  }

  &__btn-cell {
    display: flex;
    flex-direction: column;
    margin-right: auto;
  }

  &__btn-title {
    font-size: 14px;
    font-weight: 400;
  }

  &__btn-label {
    font-size: 12px;
    font-weight: 400;
    line-height: 15.86px;
    opacity: 0.7;
  }

  &__btn-fio {
    font-size: 14px;
    font-weight: 400;
    line-height: 18.51px;
  }

  &__btn-num {
    color: $gray;
    font-size: 14px;
    font-weight: 500;
    align-content: center;
  }

  &__section-search-results {
    position: absolute;
    top: 56px;
    left: 0;
    width: 100%;
    max-height: 256px;
    padding: 8px;
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid $light-gray-1;
    box-shadow: 2px 4px 24px 0 #0000001F;
    z-index: 9;
    overflow: auto;
  }

  &__section-search-result {
    width: 100%;
    height: 40px;
    border-radius: 8px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    overflow: hidden;

    &:hover {
      background-color: $light-gray-1;
      color: $dark;
    }

  }

  &__inp {
    width: 100%;
  }

  &__inp-error {
    margin-top: 4px;
    font-size: 14px;
    color: $red;
  }

}
.head {
  &_detached {
    margin-bottom: 24px;
  }
}
</style>
